import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

const getSearchState = (state: RootState) => state.search;

export const selectMemberSearchResults = createSelector(
  [getSearchState],
  (searchState) => searchState.searchMemberResults.data
);

export const selectMemberSearchLoading = createSelector(
  [getSearchState],
  (searchState) => searchState.searchMemberLoading
);

export const selectMemberSearchResultsToken = createSelector(
  [getSearchState],
  (searchState) => searchState.searchMemberResults.xMsContinuationToken
);

export const selectRoomSearchResults = createSelector(
  [getSearchState],
  (searchState) => searchState.searchRoomResults.data
);

export const selectRoomSearchResultsToken = createSelector(
  [getSearchState],
  (searchState) => searchState.searchRoomResults.xMsContinuationToken
);

export const selectPostsSearchResults = createSelector(
  [getSearchState],
  (searchState) => searchState.searchPostsResults.data
);

export const selectPostsSearchResultsToken = createSelector(
  [getSearchState],
  (searchState) => searchState.searchPostsResults.xMsContinuationToken
);

export const selectRepliesSearchResults = createSelector(
  [getSearchState],
  (searchState) => searchState.searchRepliesResults.data
);

export const selectRepliesSearchResultsToken = createSelector(
  [getSearchState],
  (searchState) => searchState.searchRepliesResults.xMsContinuationToken
);

export const selectPollsSearchResults = createSelector(
  [getSearchState],
  (searchState) => searchState.searchPollsResults.data
);

export const selectPollsSearchResultsToken = createSelector(
  [getSearchState],
  (searchState) => searchState.searchPollsResults.xMsContinuationToken
);

export const selectStorySearchResults = createSelector(
  [getSearchState],
  (searchState) => searchState.searchStoryResults.data
);

export const selectStoryCommentsSearchResults = createSelector(
  [getSearchState],
  (searchState) => searchState.searchStoryCommentsResults.data
);

export const selectStorySearchResultsToken = createSelector(
  [getSearchState],
  (searchState) => searchState.searchStoryResults.xMsContinuationToken
);

export const selectStoryCommentsSearchResultsToken = createSelector(
  [getSearchState],
  (searchState) => searchState.searchStoryCommentsResults.xMsContinuationToken
);

export const selectSearchDrawerOpen = createSelector(
  [getSearchState],
  (searchState) => searchState.isSearchDrawerOpen
);

export const selectIsSearching = createSelector(
  [getSearchState],
  (searchState) =>
    searchState.searchMemberLoading ||
    searchState.searchPostsLoading ||
    searchState.searchRepliesLoading ||
    searchState.searchRoomLoading ||
    searchState.searchStoryLoading ||
    searchState.searchStoryCommentsLoading ||
    searchState.searchPollsLoading
);

export const selectAreThereAnySearchResults = createSelector(
  [getSearchState],
  (searchState) =>
    searchState.searchStoryResults.data.length > 0 ||
    searchState.searchStoryCommentsResults.data.length > 0 ||
    searchState.searchPollsResults.data.length > 0 ||
    searchState.searchPostsResults.data.length > 0 ||
    searchState.searchRepliesResults.data.length > 0 ||
    searchState.searchRoomResults.data.length > 0 ||
    searchState.searchMemberResults.data.length > 0
);
